import { useCallback } from 'react';

import { useContextSelector as useCS } from 'use-context-selector';
import { useRequest } from 'domain/core/hooks/useRequest';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';

export const useUpdateOnboardingStep = () => {
  const userData = useCS(GlobalConfigContext, globalConfigSelectors.userData);
  const role = userData?.role?.name;

  const { send: sendJobSeeker } = useRequest({
    url: '/api/v1/profile/jobSeeker',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
    body: {},
  });

  const { send: sendRecruiter } = useRequest({
    url: '/api/v1/profile/recruiter',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
    body: {},
  });

  const saveOnboardingStep = useCallback(
    (step: number) => {
      if (role === RolesEnum.JOB_SEEKER) {
        sendJobSeeker({ onboardingStep: step });
      } else if (role === RolesEnum.RECRUITER) {
        sendRecruiter({ onboardingStep: step });
      }
    },
    [role, sendJobSeeker, sendRecruiter]
  );

  return { saveOnboardingStep };
};
